export const SLEEPIO_WHITE_LOGO =
  'https://app.sleepio.com/content/sleepio-logo-medium-white@2x__2023.09.05.21.51.58.606321.png';
export const SLEEPIO_BLUE_LOGO =
  'https://app.sleepio.com/content/sleepio-logo-medium-blue@2x__2023.09.05.21.53.07.353369.png';
export const DAYLIGHT_ORANGE_LOGO =
  'https://www.trydaylight.com/hs-fs/hubfs/Daylight%20logo.png?name=Daylight%20logo.png';
